<div class="flex items-start rounded-sm p-4 text-sm">
  <div class="mt-1">
    <div class="size-3 aspect-square rounded-full bg-if-orange-500 dark:bg-if-orange-500"></div>
  </div>
  <div class="flex-1 ml-3">
    <p class="font-semibold text-black dark:text-white">{{ getNotificationTitle(notification().action) }}</p>
    <p class="mt-2 text-grey-600 dark:text-grey-300 whitespace-pre-line">{{ getNotificationMessage(notification().action) }}</p>
    <div class="mt-3">
      @let buttonLabel = getNotificationEditButtonLabel(notification().action);
      @if (buttonLabel) {
        <button
          (click)="handleAction()"
          class="font-semibold text-if-orange-600 dark:text-if-orange-600 hover:text-if-orange-700 dark:hover:text-if-orange-400 mr-7"
        >
          {{ buttonLabel }}
        </button>
      }
      <button (click)="delete()" class="font-semibold text-grey-800 dark:text-grey-200 hover:text-grey-900 dark:hover:text-grey-300">
        Löschen
      </button>
    </div>
  </div>
</div>
